/* eslint-disable react/require-default-props */
/* eslint-disable react/no-danger */
import React from 'react';
import './KeyValueList.scss';
import { InlineEdit } from '@components/v2/InlineEdit';
import Label from '@components/Label';
export var IKeyValueType;
(function (IKeyValueType) {
    IKeyValueType["text"] = "text";
    IKeyValueType["date"] = "date";
    IKeyValueType["link"] = "link";
    IKeyValueType["address"] = "address";
})(IKeyValueType || (IKeyValueType = {}));
function KeyValueList({ items, onEdit }) {
    const getDateFormatted = (date) => {
        if (date) {
            const dateInstance = new Date(date);
            return Number.isNaN(dateInstance.getTime()) ? 'Invalid Date' : dateInstance.toLocaleDateString();
        }
        return '--';
    };
    return (React.createElement("div", { className: "keyValueListContainer" }, items.map((item) => (React.createElement("div", { className: "info-row", key: item.key },
        React.createElement(Label, { htmlFor: item.key, className: "info-key" },
            item.key,
            ":"),
        item.type === IKeyValueType.date && item.editable && (React.createElement(InlineEdit, { variant: "date", id: item.key, className: "info-value", dateValue: item.value ? new Date(item.value) : undefined, onDateChange: (date) => {
                var _a;
                if (date && !Number.isNaN(date.getTime())) {
                    onEdit === null || onEdit === void 0 ? void 0 : onEdit((_a = item.field) !== null && _a !== void 0 ? _a : '', date.toISOString());
                }
            }, label: item.key })),
        item.type === IKeyValueType.date && !item.editable && (React.createElement("span", { id: item.key, className: "info-value" }, getDateFormatted(item.value))),
        item.type === IKeyValueType.link && (React.createElement("a", { href: item.value, id: item.key, className: "qmb-link info-value", target: "_blank", rel: "noopener noreferrer" }, item.label)),
        item.type === IKeyValueType.address && (React.createElement("span", { id: item.key, className: "info-value" },
            item.value,
            " ",
            React.createElement("i", { className: "fa fa-map-marker" }))),
        item.type === IKeyValueType.text && (React.createElement(InlineEdit, { id: item.key, className: "info-value", disableEdit: !item.editable, placeholder: "Enter text...", onBlur: (e) => {
                const value = e.currentTarget.textContent || '';
                if (value !== item.value && item.field)
                    onEdit === null || onEdit === void 0 ? void 0 : onEdit(item.field, value);
            } }, item.value)))))));
}
export default KeyValueList;
